<div class="field" (activateTabIndex)="openCurrentTab($event)">
  <p-fieldset legend="Change Control Attachments">
    <div class="text-justify">
      {{ fileAttachmentsHeaderText }}
    </div>
    <bpt-file-upload
  [uploadFiles]="uploadSucceeds"
  [deleteFile]="deleteFile"
  [maxSize]="maxFileSize"
  [fileNames]="savedFiles"
  [fileLimit]="changeControlAttachmentMaxLimit"
  [fileTypes]="attachmentFileTypes"
></bpt-file-upload>
  </p-fieldset>
    <div class="buttons mt-3">
      <p-button
      appPreventDoubleClick
      *ngIf="isEditSlider"
      label="Save"
      type="submit"
      id="generalDetailsSaveButton"
      class="align-right"
      styleClass="bpt-button-compact"
      (debounceClick)="createOrUpdateChangeControl()"
    >
    </p-button>
    <p-button
    appPreventDoubleClick
    label="Next"
    type="submit"
    id="filesDetailsButton"
    styleClass="bpt-button-compact"
    class="align-right mr-3"
      (debounceClick)="openNextTab()"
    >
      </p-button>
      <p-button
        appPreventDoubleClick
        label="Previous"
        type="submit"
        styleClass="bpt-button-compact"
        id="filesPreviousButton"
        (debounceClick)="openPreviousTab()"
      >
      </p-button>
    </div>
  </div>


  <p-dialog
  [(visible)]="showDeletedFilesConfirmationModal"
  [style]="{ width: '30vw' }"
  (onHide)="closeConfirmationModal()"
  [modal]="true"
>
  <ng-template pTemplate="header">
    <span class="font-semibold text-xl">Confirmation</span>
  </ng-template>
  <div>
    <em class="pi pi-exclamation-triangle mr-2 font-semibold"></em>
    <span>{{ deleteAttachmentConfirmationMessage }}</span>
  </div>
  <ul>
    <li *ngFor="let deleteAttachment of deletedAttachments">
      {{ deleteAttachment.attachmentPath }}
    </li>
  </ul>
  <ng-template pTemplate="footer">
    <p-button
      appPreventDoubleClick
      label="No"
      type="submit"
      icon="pi pi-times"
      id="deletedFilesConfirmationNoButton"
      styleClass="p-button-outlined"
      class="align-right"
      (debounceClick)="closeConfirmationModal()"
    >
    </p-button>
    <p-button
      appPreventDoubleClick
      label="Yes"
      icon="pi pi-check"
      type="submit"
      id="deletedFilesConfirmationYesButton"
      class="align-right"
      (debounceClick)="UpdateChangeControl()"
    >
    </p-button>
    
  </ng-template>
</p-dialog>
<app-dialog *ngIf="isReasonForChangeControlUpdateRequired"[reasonValidationMessage]="reasonValidationMessage"[heading]="heading"(saveDocumentwithReason)="saveChangeControlwithReason($event)" (isModelOpen)="closeReasonDailog($event)">  
</app-dialog>

<app-confirmation-dialog *ngIf="isInActiveAssignmentGroupDialog" [InactiveAssignmentGroupField]="InactiveAssignmentGroupField" (confirmed)="saveChangeControlwithInactiveUsers()" (dialogClosed)="closeConfirmationDailog($event)">
</app-confirmation-dialog>